import { registerPlugin } from '@capacitor/core';

interface PrintReceipt {
  print: (data: {url: string}) => any;
}

export const PrintReceipt = registerPlugin<PrintReceipt>('PrintReceipt');

// export default PrintReceipt;
